module.exports = __webpack_public_path__ + "static/img/三维制作画面.2bbf6c9f.png";